import { z } from "zod";
import { CoaSetupMethod } from "../constants/domains/accounting/coaSetup";

export const coaSetupBodySchema = z.discriminatedUnion("method", [
    z.object({
        method: z.literal(CoaSetupMethod.template),
        templateId: z.string().uuid(),
    }),
    z.object({
        method: z.literal(CoaSetupMethod.entity),
        sourceEntityId: z.number().int(),
    }),
]);

export type CoaSetupBody = z.infer<typeof coaSetupBodySchema>;
